/**
 * 顔認証モーダル動作モード
 */
export enum FaceDetectionModalMode {
  /** 登録モード */
  Regist,
  /** 認証モード */
  Auth,
}

/**
 * 顔認証モーダル登録モード状態
 */
export enum FaceDetectionRegistState {
  /** 初期 */
  Init,
  /** 確認中 */
  Check,
  /** リトライ */
  Retry,
  /** 登録中 */
  Regist,
}





// WEBPACK FOOTER //
// ./src/app/feature/face-detection-modal/face-detection-modal.enum.ts